"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientErrorCreateDto = void 0;
const misc_1 = require("../../../misc");
const client_error_1 = require("../client-error");
class ClientErrorCreateDto extends (0, misc_1.generateCreateDto)(client_error_1.ClientError, ['userAgent', 'url', 'stack', 'metadata', 'message', 'level', 'replayData']) {
}
exports.ClientErrorCreateDto = ClientErrorCreateDto;
